import { models } from '@kurtosys/ksys-app-template';

export const AUTHENTICATION: models.appsInitialize.IAppAuthentication = {
	'serviceUrl': 'https://api-us.fundpress.io',
	'token': 'c79a36f3-2caf-4829-9ad0-b3b95e4de632',
};